import { useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { UserContext } from 'contexts/user';

import { ReactComponent as StoreSVG } from 'icons/store.svg';
import { ReactComponent as UserCircleSVG } from 'icons/user-circle.svg';
import { ReactComponent as BookOpenSVG } from 'icons/book-open.svg';
import { ReactComponent as SignoutSVG } from 'icons/signout.svg';

import DoctorDropdown from './dropdown/doctor';

const Dropdown = ({ onSignOut }) => {
  const { user } = useContext(UserContext);

  return user.role === 'doctor' ? (
    <DoctorDropdown user={user} onSignOut={onSignOut} />
  ) : (
    <div className="th-nav-menu-dropdown">
      <ul className="dropdown-menu dropdown-triangle-top">
        <li>
          <Link to="/profile" className="dropdown-item">
            <UserCircleSVG />
            Profile
          </Link>
        </li>
        <li className="divider" />
        <li>
          <a
            href="https://sleepdoctor.me/"
            className="dropdown-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <StoreSVG /> About SleepDoctor
          </a>
        </li>
        <li>
          <a
            className="dropdown-item"
            target="_blank"
            href="https://sleepdoctor.me/blog"
            rel="noopener noreferrer"
          >
            <BookOpenSVG />
            SleepDoctor Blog
          </a>
        </li>
        <li className="divider" />
        <li>
          <button
            className="dropdown-item"
            data-cy="sign-out"
            onClick={onSignOut}
          >
            <SignoutSVG />
            Sign out
          </button>
        </li>
      </ul>
    </div>
  );
};

Dropdown.propTypes = {
  onSignOut: PropTypes.func.isRequired,
};

export default Dropdown;
